import React, { useEffect } from "react";
import styles from "./WalletsTransactions.module.sass";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchHTXDeposits, fetchHTXWithdrawals } from "store/actions";

const WalletsTransactions = ({ selectedAsset }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { transactions } = useSelector((state) => state.crypto.htx);
  useEffect(() => {
    if (selectedAsset) { 
      dispatch(fetchHTXDeposits(selectedAsset));
      dispatch(fetchHTXWithdrawals(selectedAsset));
    }
  }, [selectedAsset]);
  return (
    <div className={styles.wrap}>

      {/* Table Card */}
      <div className={styles.cardWrapper}>
        <div className={styles.cardHead} >
          {t("Deposits & Withdraw History")}
        </div>
        <div className={styles.card}>
          <div className={`${styles.row} ${styles.head}`}>
            <div className={styles.col}>Transaction Record</div>
            <div className={styles.col}>Type</div>
            <div className={styles.col}>Amount</div>
            <div className={styles.col}>Time</div>
            <div className={styles.col}>Status</div>
          </div>

          {transactions.loadingDeposit || transactions.loadingWithdrawal ? (
            <div className={styles.loader}>Loading...</div>
          ) : transactions.data.length > 0 ? (
            transactions?.data?.map((d, index) => (
              <div className={styles.row} key={index}>
                <div className={styles.col}>
                  <div className={styles.recordId}>
                    <div>{d?.recordId}</div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.type}>
                    <div>{d?.type}</div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.amount}>
                    <div>{d?.amount}</div>
                  </div>

                </div>
                <div className={styles.col}>
                  <div className={styles.time}>
                    <div>{d?.createdAt}</div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.status}>
                    <div>{d?.status}</div>
                  </div>

                </div>
              </div>
            ))
          ) : (
            <div className={styles.empty}>{t("No transactions found")}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletsTransactions;
